import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { ManagerService } from "../../../core/services/manager.service";
import { Observable } from "rxjs";
import { map, pluck, switchMap, take } from "rxjs/operators";

@Component({
  selector: "app-lobby-sub-menu",
  templateUrl: "./lobby-sub-menu.component.html",
  styleUrls: ["./lobby-sub-menu.component.scss"],
})
export class LobbySubMenuComponent implements OnInit {
  @Input() selectedGameType: string = "";
  @Input() design: "newDesign" | "primary" = "newDesign";

  @Output() gameTypeChange = new EventEmitter<string>();
  @Output() holdemLimitChange = new EventEmitter<string>();
  @Output() omahaChange = new EventEmitter<string>();

  gameFilters$: Observable<any>;

  private pointerActive = false;
  private didDrag = false;
  private dragStartX = 0;
  private scrollStartLeft = 0;
  private readonly dragThreshold = 6;

  constructor(private managerService: ManagerService) { }

  ngOnInit() {
    this.gameFilters$ = this.managerService.lobbyFilter$.pipe(
      take(1),
      pluck("filters"),
      switchMap((lobbyFilterOptions) =>
        this.managerService.tableFilters$.pipe(
          map((tableFilters) => {
            if (tableFilters) {
              if (lobbyFilterOptions.TableType === 1) {
                return tableFilters.RingFilters;
              }
              if (lobbyFilterOptions.TableType === 2) {
                return tableFilters.SitNGoFilters;
              }
              if (lobbyFilterOptions.TableType === 4) {
                return tableFilters.TournamentFilters;
              }
              if (lobbyFilterOptions.TableType === 16) {
                return tableFilters.SpinNGoFilters;
              }
            }

            return {};
          }),
        ),
      ),
    );
  }

  onWheel(event: WheelEvent) {
    const el = event.currentTarget as HTMLElement;
    if (!el || el.scrollWidth <= el.clientWidth) {
      return;
    }

    const delta =
      Math.abs(event.deltaX) > Math.abs(event.deltaY)
        ? event.deltaX
        : event.deltaY;

    if (delta === 0) {
      return;
    }

    const prev = el.scrollLeft;
    el.scrollLeft += delta;

    if (el.scrollLeft !== prev) {
      event.preventDefault();
    }
  }

  onPointerDown(event: PointerEvent) {
    if (event.button !== 0 || event.pointerType === "mouse") {
      return;
    }

    const el = event.currentTarget as HTMLElement;
    if (!el || el.scrollWidth <= el.clientWidth) {
      return;
    }

    this.pointerActive = true;
    this.didDrag = false;
    this.dragStartX = event.clientX;
    this.scrollStartLeft = el.scrollLeft;
  }

  onPointerMove(event: PointerEvent) {
    if (!this.pointerActive) {
      return;
    }

    const el = event.currentTarget as HTMLElement;
    const dx = event.clientX - this.dragStartX;

    if (!this.didDrag && Math.abs(dx) < this.dragThreshold) {
      return;
    }

    this.didDrag = true;
    el.scrollLeft = this.scrollStartLeft - dx;
    event.preventDefault();
  }

  onPointerUp() {
    if (this.didDrag) {
      // Suppress the click that follows a drag so toggles still work on tap.
      const suppressClick = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        document.removeEventListener("click", suppressClick, true);
      };
      document.addEventListener("click", suppressClick, true);
    }

    this.pointerActive = false;
  }

  onChange(value: string) {
    this.gameTypeChange.emit(value);
  }

  onHoldemLimit(value: string) {
    this.holdemLimitChange.emit(value);
  }

  onOmaha(value: string) {
    this.omahaChange.emit(value);
  }
}
